import { render, staticRenderFns } from "./whiteLogo.vue?vue&type=template&id=8f2a3ae8&scoped=true"
import script from "./whiteLogo.vue?vue&type=script&lang=js"
export * from "./whiteLogo.vue?vue&type=script&lang=js"
import style0 from "./whiteLogo.vue?vue&type=style&index=0&id=8f2a3ae8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2a3ae8",
  null
  
)

export default component.exports